import React from 'react';
export function Header() {
  return <header className="border-b-[3px] border-brand-red bg-white" data-id="element-245">
      {/* Top bar */}
      <div className="flex items-center justify-between max-w-[1100px] mx-auto px-6 pt-[18px] pb-[14px]" data-id="element-246">
        <div className="flex flex-col" data-id="element-247">
          <div className="font-serif text-[2.1rem] font-bold text-brand-navy tracking-[-0.02em] leading-none" data-id="element-248">
            Vital<span className="text-brand-red" data-id="element-249">-</span>Wegweiser
          </div>
          <div className="font-sans text-[0.65rem] tracking-[0.14em] uppercase text-brand-gray-400 mt-1" data-id="element-250">
            Ihr Ratgeber für Gesundheit & Wohlbefinden
          </div>
        </div>
        <div className="font-sans text-[0.75rem] text-brand-gray-400 text-right leading-[1.6]" data-id="element-251">
          Dienstag, 14. April 2026
          <br data-id="element-252" />
          Ausgabe 04/2026
        </div>
      </div>

      {/* Nav bar */}
      <nav className="bg-brand-navy" data-id="element-253">
        <div className="max-w-[1100px] mx-auto px-6 flex overflow-x-auto whitespace-nowrap scrollbar-hide" data-id="element-254">
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-255">
            Startseite
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white bg-brand-red no-underline py-2.5 px-4 block transition-colors" data-id="element-256">
            Männergesundheit
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-257">
            Schlaf & Erholung
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-258">
            Ernährung
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-259">
            Naturheilkunde
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-260">
            Fitness
          </a>
          <a href="#" className="font-sans text-[0.75rem] font-medium tracking-[0.06em] uppercase text-white/75 no-underline py-2.5 px-4 block transition-colors hover:bg-brand-red hover:text-white" data-id="element-261">
            Psyche
          </a>
        </div>
      </nav>

      {/* Anzeige bar */}
      <div className="bg-[#FFF8E1] border-b border-[#F0D060]" data-id="element-262">
        <div className="max-w-[1100px] mx-auto py-[7px] px-6 flex items-center gap-3" data-id="element-263">
          <span className="font-sans text-[0.65rem] font-medium tracking-[0.1em] uppercase text-[#7B6000] bg-[#F0D060] py-[3px] px-2 whitespace-nowrap shrink-0" data-id="element-264">
            Anzeige / Advertorial
          </span>
          <span className="font-sans text-[0.72rem] text-[#7B6000] leading-[1.5]" data-id="element-265">
            Dieser Artikel ist eine bezahlte Werbekooperation. Die Inhalte
            wurden in Zusammenarbeit mit dem Hersteller erstellt und stellen
            keine redaktionelle Berichterstattung dar.
          </span>
        </div>
      </div>

      {/* Ticker bar */}
      <div className="bg-brand-gray-100 border-b border-brand-gray-200" data-id="element-266">
        <div className="max-w-[1100px] mx-auto py-1.5 px-6 flex gap-3 items-center overflow-hidden" data-id="element-267">
          <span className="font-sans text-[0.65rem] font-medium tracking-[0.1em] uppercase text-brand-red whitespace-nowrap" data-id="element-268">
            Aktuell
          </span>
          <span className="font-sans text-[0.75rem] text-brand-gray-600 truncate" data-id="element-269">
            Schlafstörungen bei Männern ab 40 nehmen zu &nbsp;·&nbsp; Neue
            Erkenntnisse zur Bioverfügbarkeit pflanzlicher Wirkstoffe
            &nbsp;·&nbsp; Phytotherapie in Deutschland: wachsende Beliebtheit
            bei Männern
          </span>
        </div>
      </div>
    </header>;
}